<script setup>
import {computed, onBeforeUnmount, ref, watch} from 'vue'
import {useRoute} from 'vue-router'
import FormHeader from '@/common/form/FormHeader'
import FormNavAndForm from '@/common/form/FormNavAndForm'
import {useFormsStore} from '@/stores/forms'
import {usePageContentDataStore} from '@/stores/pageContentData'
import {useAppStore} from '@/stores/appStore'

const route = useRoute()
const appStore = useAppStore()
const formsStore = useFormsStore()
const pageContentDataStore = usePageContentDataStore()

const formId = ref(undefined)

const tableName = computed(() => {
    if (route.name === 'pageContent') {
        return 'content'
    }
    return route.params.component
})

const id = computed(() => {
    let rawId
    if (route.name === 'pageContent') {
        const pageContentId = parseInt(route.params.pageContentId)
        const pageContentItem = pageContentDataStore.items.find(o => o.id === pageContentId)
        rawId = pageContentItem ? pageContentItem.contentId : null
    } else {
        rawId = route.params.id
    }

    const parsed = parseInt(rawId)
    return isNaN(parsed) ? null : parsed
})

const setCmsDataNavigationComponent = () => {
    appStore.navigationComponent = tableName.value.startsWith('product_variations__')
        ? 'm_products_products'
        : tableName.value
}

const init = () => {
    const isIdInvalid = id.value === null || id.value === undefined || isNaN(id.value)
    if (isIdInvalid || !tableName.value) {
        return
    }

    formId.value = `form:${tableName.value}:${id.value}`

    formsStore.createForm({
        tableName: tableName.value,
        id: id.value
    })

    setCmsDataNavigationComponent()
}

watch([id, tableName], ([newId, newTable], [oldId, oldTable]) => {
    if (newId !== oldId || newTable !== oldTable) {
        init()
    }
})

init()

onBeforeUnmount(() => {
    if (formId.value && formsStore.destroyForm) {
        formsStore.destroyForm(formId.value)
    }
})
</script>

<template>
    <div class="d-flex h-100 overflow-auto flex-column">
        <FormHeader
            v-if="formId"
            :key="'header-' + formId"
            :form-id="formId"
            :show-add-btn="true"
            :show-save-and-close-btn="true"
            :show-save-btn="true"
        />

        <FormNavAndForm
            v-if="formId"
            :key="'body-' + formId"
            :form-id="formId"
            :show-archive-btn="true"
            :show-duplicate-btn="true"
            :show-history-btn="true"
        />
    </div>
</template>